module.exports = __webpack_public_path__ + "img/ge.a5234f32.svg";